import Typography from '@mui/material/Typography';
import { ContentCopyExtension } from 'common/ContentCopyExtension/ContentCopyExtension';
import { Link, useLocation } from 'react-router';

export type CopyableLinkProps = {
  value: string;
  to: string;
  state?: any;
};

export const CopyableLink: React.FC<CopyableLinkProps> = ({ value, to, state }) => {
  const { pathname, search } = useLocation();

  return (
    <ContentCopyExtension value={value}>
      <Typography
        component={Link}
        variant="link"
        to={to}
        state={{ ...state, previousPath: `${pathname}${search}` }}
        sx={{
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        {value}
      </Typography>
    </ContentCopyExtension>
  );
};
